export const ACTIONS = {
  ADD_PRODUCT: "ADD_PRODUCTS",
  ADD_TO_CART: "ADD_TO_CART",
  REMOVE_FROM_CART: "REMOVE_FROM_CART",
  CHANGE_CART_QTY: "CHANGE_CART_QTY",
  FETCH_DATA: "FETCH_DATA",
  PRODUCTS_SORTED_ACC_TO_PRICE: "PRODUCTS_SORTED_ACC_TO_PRICE",
  MOST_PURCHASED_PRODUCT: "MOST_PURCHASED_PRODUCT",
  PRODUCTS_SORTED_ACC_TO_STOCK: "PRODUCTS_SORTED_ACC_TO_STOCK",
  PPL: "PPL",
  PPL_ID: "PPL_ID",
  PRODUCTS_PURCHASED_BY_INDIVIDUAL_USER:
    "PRODUCTS_PURCHASED_BY_INDIVIDUAL_USER",
  USER_NAME: "USER_NAME",
};
